import { useDesktopNavigation } from '@components/navbar/desktop/DesktopNavigationContext'
import { ProductSearchIcon } from '@components/navbar/icons'
import useHasSystemRole from '@hooks/useHasSystemRole.ts'
import { routesFactory } from '@utils/routes.ts'

import NavItem from './NavItem'

function InvestigatorNavItem() {
  const { isActive, storeId, scanId } = useDesktopNavigation()

  const isDeveloper = useHasSystemRole('DEVELOPER')
  if (!isDeveloper) return null

  return (
    <NavItem
      to={routesFactory.mapInvestigator(storeId, scanId!)}
      label="Map Investigator"
      isActive={isActive('map-investigator')}
      icon={<ProductSearchIcon size={20} />}
    />
  )
}

export default InvestigatorNavItem

